import Profile from "../../../components/common/profile";

export default function ProfileView() {
  return <Profile />;
}
